// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-aster -> z-modular-aster -> fuze-lucan
// Generated: 2026-11-03T18:40:04.505Z
// Counts: 8 design, 77 content, 58 slot group, 5 collection binding, 7 section, 4 style

export const designOverrides = {
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#707070",
    "mappedField": null
  },
  "design.SpecialOfferBanner.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_4"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Nunito', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Accessibility</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_amenities_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Amenities</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Designed for Living</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.intro": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to a world of unmatched luxury and convenience at <span data-type=\"field-token\" data-field=\"property_name\"></span>. Our amenity offerings redefine the standard of modern living, providing an exquisite backdrop to complement your lifestyle.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.interiorHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Apply Now</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_color_4"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_contactus_blurb"
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Contact Us</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "conveniencecallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "conveniencecallout.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Convenience All Around</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_floorplans_blurb"
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Floor Plans</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.feature_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.feature_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Spacious Apartment Homes</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.contact_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Contact</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.follow_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Follow Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.office_hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Office Hours</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.visit_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Visit Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_gallery_blurb"
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Gallery</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Discover dog-friendly apartments in Meridian, Idaho. Enjoy pet-friendly living spaces tailored for you and your furry friends.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Dog-Friendly Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Interactive Map</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Have questions about how to start living at your new home? Our dedicated leasing team at <span data-type=\"field-token\" data-field=\"property_name\"></span> is here to assist you.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Let's Connect</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_neighborhood_blurb"
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Neighborhood</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Pet Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyinfo.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.info": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.restrictions": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "petpolicyinfo.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Privacy Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Modern Main Street living, built smarter.</strong> At FUZE Lucan, you get a fresh take on apartment living in Lucan: Canadian-built, Canadian-owned suites crafted with innovative off-site steel construction, extra sound-proofing, 9' ceilings, key-fob entry, premium wood-style flooring, stainless steel appliances, in-suite laundry, and glass-railing balconies. Choose from smart studio, one-bedroom, and two-bedroom <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> designed for everyday ease.</p><p><strong>Connected to the best of Lucan.</strong> Step outside to the Community Memorial Centre, local parks, the dog park, outdoor pool, and sports fields, with Main Street favourites like The Hub Roadhouse, Dessert First Bakery Cafe, Thai Pad, Donnelly’s Cafe, Lucan Foodland, and other everyday stops nearby. Back home, a <a class=\"richtext-link\" href=\"/amenities\">fitness centre, lounge and games room</a>, community kitchen, indoor bike storage, pet wash station, elevator, parking, storage, and on-site management keep life streamlined—while Highway 4 puts London, Grand Bend, and Stratford within an easy regional drive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Luxury Apartment Living</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_residentaccess_blurb"
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Resident Access</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.help_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Need Help? Call Us</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.portal_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resident Portal</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Schedule A Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Sitemap</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "testimonials.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Testimonials</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Thank You</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Virtual Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Apartment Amenities in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.interiorHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interior Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "better-built-living-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Better Homes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Community &amp; Apartment Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "meet-the-team-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Meet the local team dedicated to helping you find the perfect home at <span data-type=\"field-token\" data-field=\"property_name\"></span> and guiding you every step of the way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "meet-the-team-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Your On-Site Team</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "meet-the-team-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Meet The Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "meettheteamintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Here to Help You Feel at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.disable_self_guided_tour": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Virtual Apartment Tours in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>See the details before you tour.</strong> Browse FUZE Lucan’s photo gallery for a closer look at bright, modern apartments and the shared spaces that shape your day. Picture stainless steel appliances against clean cabinetry, premium wood-style flooring carrying through open living areas, and glass-railing balconies that add light and a polished finish.</p><p>Move from suite views to amenity scenes: a fitness centre ready for quick workouts, a lounge and games room made for downtime, and a community kitchen and dining room with space to gather. Like what you see? Explore <a class=\"richtext-link\" href=\"/virtual-tour\">virtual tours</a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to experience the finishes, layouts, and building atmosphere in person.</p>",
    "generatedValue": null,
    "mappedField": "property_gallery_blurb"
  },
  "lifestyleresidenttypes.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>FUZE Lucan is home to a mix of neighbours: downsizers trading a house for low-maintenance living, young professionals driving Highway 4 to jobs in London, and remote workers who like small-town quiet. Lucan Biddulph is still a farming community at heart, with a Main Street full of local cafés, so residents get rural calm with city access close by. With <a href=\"/floor-plans\">studio, one- and two-bedroom suites</a> and a pet-friendly policy, there's room for everyone from solo renters to couples with a dog.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "conveniencecallout.background": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "conveniencecallout.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.feature_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "flexiblelivingprograms.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a4a-d878-773a-a930-cec812802db9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "FLEX logo"
      }
    }
  },
  "flexiblelivingprograms.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a42-1fb9-70ab-b6d9-28b9225354db.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Obligo logo"
      }
    }
  },
  "flexiblelivingprograms.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8bbe-70aa-b774-4fa553335ff2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Beagle logo with a dog wearing a tie inside an orange square."
      }
    }
  },
  "flexiblelivingprograms.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8b62-7369-a1e1-504e1b5e29e7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "RentCafe logo"
      }
    }
  },
  "flexiblelivingprograms.card5_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a4a-247d-7396-b23b-7a6eeab770d3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Guarantors logo."
      }
    }
  },
  "flexiblelivingprograms.card6_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a15a46-8c3e-7295-89e2-87ef61ff7baa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pineapple logo"
      }
    }
  },
  "lifestylefeaturerows.row_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a1412f-1b00-7100-aba1-8fa7e604edd5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Lucan apartment buildings on Main Street with modern facades and FUZE LUCAN signage."
      },
      "eyebrow": {
        "type": "GENERATOR",
        "generatedValue": "Better-Built Living"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Steel-Built Comfort on Lucan's Main Street"
      },
      "body": {
        "type": "GENERATOR",
        "generatedValue": "<p>FUZE Lucan is Canadian-built and Canadian-owned, made with innovative off-site steel construction and extra sound-proofing for quieter, more solid everyday living. Inside, 9' ceilings, wood-style flooring, stainless steel appliances, in-suite laundry, and glass-railing balconies come standard in every studio, one-, and two-bedroom suite.</p>"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/better-built-living"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Explore the Build"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "lifestylefeaturerows.row_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/flexible-living-program"
      }
    }
  },
  "lifestylefeaturerows.row_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/rewards-programs"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-2f68-732f-a851-5bc03d7347ab.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Lucan resident lounge and games room with a pool table, foosball table, fireplace and lounge seating"
      }
    }
  },
  "amenitieslist.apartment_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-3c55-725f-aac7-8ebeaa165440.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living and dining area with white sofa, coffee table, and dining set. Large windows offer exterior views."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Bright Living & Dining Area"
      }
    }
  },
  "amenitieslist.apartment_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-5f44-703b-8fc7-7ba011876498.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark wood cabinets and white subway tile backsplash."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with Stainless Steel Appliances"
      }
    }
  },
  "amenitieslist.apartment_slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-7cc1-72ec-8f82-ec0a98988c7d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a king-size bed, nightstands, and a view into the bathroom."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Comfortable Bedrooms"
      }
    }
  },
  "amenitieslist.apartment_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-94f5-73b0-944d-35037bc12e5d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern laundry room with stacked washer and dryer, sleek cabinetry, and ample storage space."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "In-Suite Laundry"
      }
    }
  },
  "amenitieslist.apartment_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-8488-723e-918d-249b0a479751.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with a floating vanity, toilet, and bathtub with a shower curtain."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Modern Bathroom with Tub/Shower"
      }
    }
  },
  "amenitieslist.apartment_slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4b43-70bc-b847-3e2f150170c7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment interior with a dining table, chairs, and a kitchen with black cabinetry."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Dining"
      }
    }
  },
  "amenitieslist.community_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-c1da-776a-8266-997dee1d9f88.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment gym with cardio and weight machines, dumbbells, and large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Centre"
      }
    }
  },
  "amenitieslist.community_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-e772-7257-83be-0fcccf933466.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community lounge area with a modern kitchen island, dining table, fireplace, and TV."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Community Kitchen & Lounge"
      }
    }
  },
  "amenitieslist.community_slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a14132-151e-7738-8300-634aeeafa3cf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor seating area with picnic tables, benches, and bike racks in front of apartment buildings."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor Picnic Area"
      }
    }
  },
  "amenitieslist.community_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a14131-bd58-779c-b4d2-a8b6cd432a9b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community game room with a foosball table and a pool table."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Games Room"
      }
    }
  },
  "amenitieslist.community_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-b893-70ac-a61a-0652996dfb4d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Pet grooming station with a stainless steel tub and faucet"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pet Wash Station"
      }
    }
  },
  "amenitieslist.community_slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-a9b4-7198-832b-1ed0f6b8505a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Secure indoor bicycle storage area with wall-mounted racks and multiple bikes."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Indoor Bike Storage"
      }
    }
  },
  "betterbuiltclosing.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a14132-151e-7738-8300-634aeeafa3cf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor seating area with picnic tables, benches, and bike racks in front of apartment buildings."
      }
    }
  },
  "betterbuiltconstruction.row_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a1412f-1f62-7139-9740-08332776ccb5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Multistory apartment building exterior with balconies and large windows"
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a1412f-1b00-7100-aba1-8fa7e604edd5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern FUZE Lucan apartment buildings with exterior signage in Lucan Biddulph, Ontario"
      }
    }
  },
  "conveniencecallout.feature_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-3c55-725f-aac7-8ebeaa165440.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright apartment living and dining area with a white sofa, coffee table, dining set, and large windows"
      }
    }
  },
  "floorplanslist.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a1412f-1f53-739d-8d5b-7c1eec1072cf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a white couch, coffee table, and a glimpse of a bedroom through glass doors."
      }
    }
  },
  "floorplanslist.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-3c55-725f-aac7-8ebeaa165440.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living and dining area with white sofa, coffee table, and dining set. Large windows offer exterior views."
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a1412f-1dd8-7218-adb4-81961ddd700f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fuze Lucan resident lounge with billiards and foosball tables, a modern fireplace, and comfortable seating"
      }
    }
  },
  "lifestyleclosingcta.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a14132-2aa6-71bd-8de7-e563764ba907.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern apartment building with red and gray accents, balconies, and a parking lot."
      }
    }
  },
  "lifestylefeaturerows.row_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-e613-77ad-813b-69bed0d9cab9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern community lounge with a full kitchen, fireplace, and gathering tables."
      },
      "eyebrow": {
        "type": "GENERATOR",
        "generatedValue": "Community"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Neighbours Who Know Your Name"
      },
      "body": {
        "type": "GENERATOR",
        "generatedValue": "<p>Our on-site team plans regular resident get-togethers, so new arrivals settle in fast and longtime neighbours stay connected. Gatherings take over the lounge and community kitchen, with pool, foosball, the big-screen TV, and a fireplace on the go. Reach out to the leasing office to hear what's coming up next.</p>"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/contact-us"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Ask What's On"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "lifestyleresidenttypes.type_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faHouseChimneyUser"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Downsizers & Empty Nesters"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Elevator access and key-fob entry throughout</li><li>On-site management and maintenance handle the upkeep</li><li>Roomy 876 sq ft two-bedroom, two-bath layouts</li><li>Walk to Foodland, the pharmacy, and Main Street</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faUsers"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Social Butterflies"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Staff-organized resident get-togethers</li><li>Games room with pool and foosball tables</li><li>Community kitchen for hosting friends</li><li>Fireplace lounge with a big-screen TV</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faLaptopFile"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Remote Workers"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>High-speed internet access in every suite</li><li>Communal tables and bar seating for laptop days</li><li>Extra sound-proofing keeps video calls quiet</li><li>Package lockers catch deliveries while you work</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faTree"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor Lovers"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Lucan Conservation Area close to home</li><li>Parks, sports fields, and outdoor pool nearby</li><li>Indoor bike storage plus outdoor bike racks</li><li>Balcony sunsets with local wildlife sightings</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faBriefcase"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "London Commuters"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Highway 4 runs straight into London</li><li>Easy drives to Western and London hospitals</li><li>EV charging stations in the parking lot</li><li>On-site fitness centre for before- or after-work workouts</li></ul>"
      }
    }
  },
  "lifestyleresidenttypes.type_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "icon": {
        "type": "GENERATOR",
        "generatedValue": "faPaw"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pet Parents"
      },
      "bullets": {
        "type": "GENERATOR",
        "generatedValue": "<ul><li>Paw-friendly community; breed restrictions may apply</li><li>On-site pet wash station for muddy paws</li><li>Lucan's dog park just around the corner</li><li>Pet Valu nearby for food and supplies</li></ul>"
      }
    }
  },
  "meettheteamcontactcta.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167810/01a1412f-1b00-7100-aba1-8fa7e604edd5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of the modern Fuze Lucan apartment buildings with the Fuze Lucan and Quadro signs."
      }
    }
  },
  "meettheteammembers.member_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Morgan G."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Property Manager"
      },
      "bio": {
        "type": "VALUE",
        "customValue": "<p>Morgan is a dedicated Property Manager who is passionate about helping people find their perfect home. With a strong commitment to service and a passion for building lasting relationships, she strives to make every experience personal and seamless. Outside of work, Morgan enjoys gardening, hiking, and getting lost in the great outdoors.</p>"
      },
      "photo": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a16047-ec98-704a-9de7-da827e1d77c2.webp"
      },
      "photo_alt": {
        "type": "VALUE",
        "customValue": "A young woman with red hair and a plaid jacket poses in a snowy outdoor setting."
      }
    }
  },
  "meettheteammembers.member_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "photo": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a16047-d18d-704f-83c6-c7a8f07616e6.webp"
      },
      "photo_alt": {
        "type": "VALUE",
        "customValue": "A smiling woman with long brown hair and a white long-sleeved shirt stands in front of a slatted wall."
      },
      "name": {
        "type": "VALUE",
        "customValue": "Justiana M."
      },
      "bio": {
        "type": "VALUE",
        "customValue": "<p>Justiana is happy to be working as a Leasing Professional here at FUZE! She has been working in the industry for a few years now. In her free time, she enjoys playing rugby and spending time with family and friends. Justiana’s favourite amenity is the Rooftop Patio!</p>"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Leasing Professional"
      }
    }
  },
  "meettheteammembers.member_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "photo": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a16047-c827-775b-b1ea-cb7266bdc9d5.webp"
      },
      "photo_alt": {
        "type": "VALUE",
        "customValue": "A man on a rooftop with industrial equipment and a green landscape in the background."
      },
      "name": {
        "type": "VALUE",
        "customValue": "Tim F."
      },
      "bio": {
        "type": "VALUE",
        "customValue": "<p>Tim brings over 25 years of experience in the maintenance industry, combining expertise with a personable approach. Known for his sense of humor and ability to make people laugh, he creates a positive and welcoming environment for both colleagues and residents. Outside of work, Tim enjoys writing, often exploring new ideas and stories.</p>"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Maintenance Supervisor"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117ca-4030-71fd-a947-34b1801fc401.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lucan Conservation Area, a green outdoor space near FUZE Lucan in Lucan Biddulph, Ontario"
      }
    }
  },
  "photoslider.slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4929-775f-b677-4f826c4f50df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living and dining area with a view into the bedroom through glass sliding doors."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open Living & Dining"
      }
    }
  },
  "photoslider.slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-2f68-732f-a851-5bc03d7347ab.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern lounge area with pool table, foosball table, fireplace, and comfortable seating."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Games Room"
      }
    }
  },
  "photoslider.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-c1da-776a-8266-997dee1d9f88.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment gym with cardio and weight machines, dumbbells, and large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Centre"
      }
    }
  },
  "photoslider.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4fd6-73bd-961f-b987ecb88bac.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark wood cabinets, white subway tile backsplash, stainless steel appliances, and a sleek faucet."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Stainless Steel Kitchens"
      }
    }
  },
  "photoslider.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-67a5-75cc-8aad-c7869a280b23.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed and nightstand, leading to a living room and balcony."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Bright Bedrooms"
      }
    }
  },
  "photoslider.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-f3a4-703a-8902-625edccf09ac.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern co-working space with communal tables, bar seating, and a full kitchen."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Community Kitchen & Co-Working"
      }
    }
  },
  "rewardsprograms.program1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-e772-7257-83be-0fcccf933466.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Lucan community lounge with a full kitchen island, large dining table, fireplace, and TV for resident gatherings"
      }
    }
  },
  "rewardsprograms.program2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-f3a4-703a-8902-625edccf09ac.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Lucan co-working space with communal tables, bar seating, and a full kitchen"
      }
    }
  },
  "rewardsprograms.program3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-2f68-732f-a851-5bc03d7347ab.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Lucan resident lounge and games room with a pool table, foosball, fireplace, and lounge seating"
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167810/01a117cd-4929-775f-b677-4f826c4f50df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "FUZE Lucan apartment living and dining area with a sofa and dining table, and a view into the bedroom through glass sliding doors"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photoslider.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      2,
      3,
      7,
      11,
      10,
      9
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      22,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52
    ],
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": 12,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_eca02070-acba-4e21-a0b6-64afe8463b40",
      "custom_558abf4d-e91d-4c80-8d00-1e6c280ac646",
      "custom_e84febed-4b23-476c-be0b-624a3dc3135d",
      "custom_93c2d727-0780-4a7c-802e-e335df7d6fcc",
      "custom_b515451c-f13c-4a26-9521-1d1cef025a02",
      "custom_b41da4f0-4ace-4bda-9bd7-33a96dbc5ab7",
      "custom_096275cb-85d9-4a62-aa69-c2d5a5fe309c",
      "custom_14a9a071-dfd2-4ae8-928e-16290854c644",
      "custom_78452196-6e66-449a-a5b0-b17ba344be40",
      "custom_03125eef-f2c1-4289-959b-ad3dc8062b15",
      "custom_d68fdd8a-ffd0-4512-9a8b-2cdc47ad010d",
      "custom_4c81f262-19dd-4949-bffe-5ec858954230",
      "custom_3c4bc520-214c-4c97-aad3-d1ff7e2d49c1",
      "custom_7f8a4873-c68c-4d5a-9f16-18c849f55b9a",
      "custom_95df3ecd-1ab8-4837-86d5-538c4ac830ae",
      "custom_5b4f78b9-1b97-47a2-96be-c0d2685c245c",
      "custom_1aa5aa13-87ab-487c-8c0e-f55ce15398f5",
      "custom_06b4f6ab-1f2a-4997-b54c-5f14349ac093",
      "custom_a6b2654e-22c3-4a85-9d36-52928e80bbff",
      "custom_bf0373eb-e1a7-4a0b-8810-596abf74c985",
      "custom_4631a83e-957d-4399-8d5b-6ab12b3a01be",
      "custom_d4ca5088-8bbb-4fa2-9bb1-2f2a459eb3f2",
      "custom_655ebccb-44af-4d60-962f-29cb3607f2f3",
      "custom_d3661bda-7473-4767-995f-cee41331c6f5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "testimonials.background": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_3f31c63e1b8f50406f06786a",
      "ec_85b7e6982519f2176ab3bc78",
      "ec_d8f0041f7f88b8d1acd62be9",
      "ec_f1d588d43b6854e284c0c832",
      "ec_eb274f833481acd15c2aba55",
      "ec_96ab30268b87bde5205ef423",
      "ec_b9492029e7a75b0783734300",
      "ec_5dfa256bb3b5f122c7363952",
      "ec_50503f3a563fa379b6570698",
      "ec_dc467481643d6f8235b97cdf",
      "ec_f970e8cc2673a53b6e54cf65",
      "ec_3cbe019c8f5b758b93b4fda6",
      "ec_e0208e559b9dd31c61488fe8",
      "ec_461fd66e170a5c4fccc71007",
      "ec_23d71a6a42ed59094ee3fb25",
      "ec_c4fbb7c0fdbf69a1d87388c8",
      "ec_76bcc428ba8bf1fe2721796a",
      "ec_943d952316e1c5254f4c54f2",
      "ec_862f064928aee3770efeb584",
      "ec_dd3680dabdb29ab7647def1e",
      "ec_9a123d87370680f47439633d",
      "ec_9822a7ee8e8707ae51c15d56",
      "ec_e53b0f0f4fddbd8ac6d9b2db",
      "ec_96f3939b88e05a063d768de8",
      "ec_fd16f77aeb4706199b750304",
      "ec_8e1f83703d519f86d0b2775c",
      "ec_e0564e6aae366d866ef255f6",
      "ec_80ed5b29f4ba19d2ba225174",
      "ec_5e76324bf8bd3a910a08e2d2",
      "ec_27174398e20e8881c1793e50",
      "ec_fdbf38520495d0e261733d15",
      "ec_97cb791183db6d2356ee31b4",
      "ec_612daf9d445a66bc3c22efc6",
      "ec_c1644aedb2ffc9fd7ec5977a",
      "ec_b2588c5f95b8187b86484c8b",
      "ec_cd60c1b102e1d025679d21ec",
      "ec_014d9acd7ce42bc93627398c",
      "ec_d2280e8dc5f10d34b9c403c2",
      "ec_9cdea505abc854a817626289",
      "ec_a2a2e2a26d7b9edbdf240349",
      "ec_a6bb41b2e616a8e462e1240e",
      "ec_e83af97dd012ff9b22b9a11b",
      "ec_4325571f38e0e984e7154472",
      "ec_4bccf717163cc9e96a82385b",
      "ec_f10de4a49c75aa3a06837128",
      "ec_0e3d3db7b294403913697b8a",
      "ec_351060c8e797c222c93b934e",
      "ec_db4978eb8b96edfff1eed7fc",
      "ec_8b3d78158363ccddfd1c8a84",
      "ec_736ab18430b557342916d411"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "virtualtourembed.tours": {
    "limit": null,
    "hiddenIds": [
      "ec_a25a084339015fc82502a63f",
      "custom_82d4b341-a006-41e5-89f5-071f5162f111"
    ],
    "orderedIds": [
      "ec_835a4a868a162e708568226f",
      "ec_a25a084339015fc82502a63f"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "funnel-fenix-chatbot",
      "blockId": "funnel-fenix-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.BetterBuiltConstruction": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.block:engrain-sitemap": {
    "properties": {
      "paddingTop": "50px",
      "paddingRight": "150px",
      "paddingBottom": "150px",
      "paddingLeft": "150px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "backgroundColor": "#fefefe"
    }
  },
  "_section.LifestyleFeatureRows": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  }
};
